import gameAssets from "@themed-assets";
import {
  checkToDisplayValueInK,
  checkToDisplayValueInCr,
  checkToDisplayValueInL,
  parseDecimalValuesOfNumber,
} from "@/Common/utils/GameUtils";
import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import useTourneyDetails from "@/src/hooks/utils/useTourneyDetails";
import useCreateGame from "@/src/hooks/utils/useCreateGame";
import useLobbyConnectionStatus from "@/src/hooks/data/useLobbyConnectionStatus";

function TourneyDetailsTable({ selectedTourneyDetails, isEmpty = false }) {
  const tourneyDetails = useTourneyDetails();
  // useEffect(() => {
  //   tourneyDetails?.fetchTourneyTables(selectedTourneyDetails?.tourneyId)
  //   return () => {}
  // }, [selectedTourneyDetails])

  const navigate = useNavigate();
  const {
    tourneyTablesStatusList = [],
    tourneyId,
    tourneyStatus,
    tourneyIdentifier,
    activePlayerForTourney,
    activeTableCount,
    averageChips,
  } = selectedTourneyDetails;

  const { createTourneyLackTable } = useCreateGame();

    const { connected } = useLobbyConnectionStatus();
  

    useEffect(() => {
      if(connected){
        tourneyDetails?.fetchTourneyTables(tourneyId);
      }
    }, [tourneyId, connected])
  //   const { connected } = useLobbyConnectionStatus();

  // const tourneyTablesStatusList = tourneyDetails?.tourneyTablesStatusList;

  // fetchTourneyTables

  const handleGameTableClick = (table) => {
    console.log("tables: ", table);
    createTourneyLackTable(table, selectedTourneyDetails);
    // navigate('/game');
  };

  return !tourneyTablesStatusList || tourneyTablesStatusList?.length == 0 ? (
    <div>
      <div className={`h-80 flex flex-col items-center justify-center`}>
        <img src={gameAssets.TableEmptyState} />
        <div className={`text-sm text-secondary mt-4`}>
          Table will shown once tourney started ddd
        </div>
      </div>
    </div>
  ) : (
    <div>
      {/* section 1 */}
      {activeTableCount > 0 && (
        <div className="mb-3 bg-foreground text-white rounded-300 p-4">
          <div className={`flex items-center justify-between rounded-md  `}>
            <div className="text-xs text-center font-normal text-secondary w-1/3">
              Total Tables
            </div>
            <div className="text-xs text-center font-normal text-secondary w-1/3 ">
              Players Left
            </div>
            <div className="text-xs text-center font-normal text-secondary w-1/3 ">
              Avg Chips Stack
            </div>
          </div>
          <div className={`flex items-center justify-between rounded-md  mt-1`}>
            <div className="flex items-center justify-center w-1/3">
              <img src={gameAssets.GameTableIcon} />
              <div className="text-sm text-center font-bold text-primary ml-1">
                {activeTableCount}
              </div>
            </div>
            <div className="flex items-center justify-center w-1/3">
              <img
                src={gameAssets.userIcon}
                width={14}
                height={14}
                className="object-cover"
              />
              <div className="text-sm text-center font-bold text-primary ml-1 ">
                {`${parseDecimalValuesOfNumber(
                  activePlayerForTourney,
                  2,
                  checkToDisplayValueInK(activePlayerForTourney),
                  checkToDisplayValueInL(activePlayerForTourney),
                  checkToDisplayValueInCr(activePlayerForTourney)
                )}`}
              </div>
            </div>
            <div className="text-sm text-center font-bold text-primary w-1/3 ">
              {averageChips}
            </div>
          </div>
        </div>
      )}

      {/* section 2 */}
      <div className="bg-foreground text-white rounded-md p-4 space-y-2">
        <div
          className={`flex items-center justify-between px-3 py-3 rounded-md `}
        >
          <div className="text-xs font-bold text-secondary w-2/8">Table ID</div>
          <div className="text-xs font-bold text-secondary w-2/8 text-center">
            Players
          </div>
          <div className="text-xs font-bold text-secondary w-3/8 ">
            Max / Min Chips
          </div>
          <div className="text-xs text-secondary w-1/8"></div>
        </div>

        <div className="mt-4">
          {tourneyTablesStatusList &&
            tourneyTablesStatusList?.map((eachTableStatus, index) => (
              <div
                key={index}
                className={`flex items-center justify-between px-3 py-2.5 mb-2 rounded-md bg-linear-to-r from-surface/20 to-accent/20 text-primary`}
                onClick={(e) => {
                  e.preventDefault();
                  handleGameTableClick(eachTableStatus);
                }}
              >
                <div className="text-sm font-bold text-primary underline w-2/8 ">
                  {`Table #${eachTableStatus.tableId?.slice(-2)}`}
                </div>
                <div className="text-sm font-bold text-primary w-2/8 text-center">
                  {eachTableStatus.players}
                </div>
                <div className="text-sm font-bold text-primary w-3/8 ">
                  {`${parseDecimalValuesOfNumber(
                    eachTableStatus.largest,
                    2,
                    checkToDisplayValueInK(eachTableStatus.largest),
                    checkToDisplayValueInL(eachTableStatus.largest),
                    checkToDisplayValueInCr(eachTableStatus.largest)
                  )}/${parseDecimalValuesOfNumber(
                    eachTableStatus.smallest,
                    2,
                    checkToDisplayValueInK(eachTableStatus.smallest),
                    checkToDisplayValueInL(eachTableStatus.smallest),
                    checkToDisplayValueInCr(eachTableStatus.smallest)
                  )}`}
                </div>
                <div className="text-sm font-medium text-primary w-1/8 flex items-end justify-end">
                  <img src={gameAssets.ChevronRight} />
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default TourneyDetailsTable;

const tourneyDetails = {
  winnersPayoutWithBonus: {},
  tourneyId: "reymw",
  tourneyName: "Parent 🌍",
  blindStructureLevel: 5,
  childBlindStartLevel: 1,
  blindStructureEndLevel: 0,
  consolidationLogic: "High Stack Forward",
  flightXThreshold: 2,
  highlighted: false,
  similarFlights: ["wsoik"],
  allFlightsEnded: true,
  tournamentType: "Flight_Parent",
  totalPrize: "",
  currentLevel: "44/44",
  tourneyStatus: "LIVE",
  tourneyStartTime: 1752049800,
  tourneyEndTime: 0,
  levelDuration: 60,
  registeredPlayerCount: 481,
  tourneyDescription: null,
  gameDefID: null,
  parentTourney: "",
  parentTourneyName: "",
  totalWinners: 0,
  lateRegistrationAllowed: false,
  lateRegistrationStatus: null,
  lateRegistrationDuration: 0,
  lateRegisterEntryAmount: 0,
  lateRegisterStartingStack: 0,
  lateRegistrationsCount: 0,
  gameType: "TEXAS_HOLDEM",
  smallBlind: 50,
  bigBlind: 100,
  isRITEnabled: false,
  maxPlayers: 0,
  isStraddleEnabled: false,
  isSNG: false,
  anonymous: false,
  nodeIps: ["13.127.91.20"],
  registrationStartTime: 1752043740,
  registrationEndTime: 1752049800,
  announcementStartDate: 1752043680,
  minPlayers: 0,
  entryFee: 0,
  tourneyRake: 0,
  buyIn: 0,
  cashType: null,
  prizePayoutType: null,
  prizePool: 100,
  tourneyRules: "Tets",
  isFeatured: true,
  extraTime: 0,
  totalAddOns: 0,
  addOnAmount: 0,
  totalReBuyIns: 0,
  reBuyInAmount: 0,
  startingChipsCount: 0,
  playersPerTable: 6,
  reEntry: null,
  payoutType: "Dynamic",
  createdAt: "1752043697839",
  tournamentLobbyType: "Normal",
  winTheButton: false,
  breakEven: true,
  dynamicPoolPrize: 33189,
  totalTimeForTimerTourney: null,
  rebuyFee: null,
  rebuyLevel: null,
  noOfRebuys: null,
  prizePoolTickets: 0,
  lateRegEnded: false,
  childTourneys: [],
  priorityNode: "13.127.91.20",
  prizePoolType: "Dynamic",
  inTheMoney: false,
  totalReEntryCount: 0,
  totalRebuyCount: 0,
  totalAddOnCount: 0,
  displayWinners: 0,
  depositTourneyFlag: false,
  allowedFreeRegistrations: 0,
  allowedTicketRegistrations: 0,
  minAddCashAmount: 0,
  addCashTicketRegistration: true,
  depositorDirectRegistrations: 0,
  depositorTicketRegistrations: 0,
  averageChips: 5500,
  breakInProgress: false,
  breakStartTime: 0,
  breakEndTime: 0,
  lateRegEndTime: 0,
  childTourneyDetails: [],
  tourneyCompleteViaAtInTheMoney: false,
  parentTourneyPrizePool: 0,
  maxRebuyCount: -1,
  pauseFinalTable: false,
  bountyTourney: false,
  bountyBuyIn: 0,
  bountyPool: 0,
  bountyCredit: 0,
  bountyTourneyType: null,
  totalBountyPrizePool: 100,
  bountyTourneyPrizePool: 0,
  familyName: null,
  tourneyTabs: [],
  tourneyIdentifier: "upcomingTourneys",
  tourneyPlayerStatus: "NOT_REGISTERED",
  isAlreadyRegisteredTourney: false,
  isFlightTourney: true,
  isFlightParentTourney: true,
  bustedOut: false,
  activePlayerForTourney: 481,
  hideRegistrationCTAButtons: false,

  buiInAmount: 0,
  startingStack: 0,
  nextLevel: "Max Level Reached",
  nextBreak: "Next break in 5 Mins",
  tourneyRegisteredPlayersStatusList: [],
  //   {
  //     "domainName": "wss://15.206.157.198:8008/websocket",
  //     "nodeIp": "15.206.157.198",
  //     "tableID": "TOTPYT070725-2201587157198trhej",
  //     "numberOfPlayers": 6,
  //     "highestChips": 5690,
  //     "lowestChips": 5400
  // }
  tourneyTablesStatusList: [
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000166079120gwtu0",
      players: 6,
      largest: 5490,
      smallest: 5490,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000168879120diqch",
      players: 6,
      largest: 5480,
      smallest: 5480,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000169679120ycbpu",
      players: 6,
      largest: 5480,
      smallest: 5480,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000169979120akvk9",
      players: 6,
      largest: 5480,
      smallest: 5480,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000169179120wfmy6",
      players: 6,
      largest: 5480,
      smallest: 5480,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000166279120fjmo8",
      players: 6,
      largest: 5490,
      smallest: 5490,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000167879120qvx8f",
      players: 6,
      largest: 5480,
      smallest: 5480,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-0001648791204gn3m",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000159779120puckl",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000156579120391y5",
      players: 6,
      largest: 5550,
      smallest: 5550,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000174479120isyiw",
      players: 5,
      largest: 5440,
      smallest: 5440,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-0001712791209607c",
      players: 6,
      largest: 5470,
      smallest: 5470,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000158379120mtb33",
      players: 6,
      largest: 5520,
      smallest: 5520,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000166579120uonl7",
      players: 6,
      largest: 5490,
      smallest: 5490,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-0001624791207f6k3",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-0001613791203xahi",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000157079120uxcxc",
      players: 6,
      largest: 5540,
      smallest: 5540,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-0001657791200pi4j",
      players: 6,
      largest: 5490,
      smallest: 5490,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000155279120ha4qm",
      players: 6,
      largest: 5600,
      smallest: 5600,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-0001673791208vpzr",
      players: 6,
      largest: 5490,
      smallest: 5490,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000164079120rq0kl",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000168179120mu8wc",
      players: 6,
      largest: 5480,
      smallest: 5480,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000172779120uhkri",
      players: 6,
      largest: 5460,
      smallest: 5460,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000161979120aj5ia",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000155479120xejnn",
      players: 6,
      largest: 5590,
      smallest: 5590,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000164579120n55lf",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000157279120b0lu0",
      players: 6,
      largest: 5540,
      smallest: 5540,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000164379120fxxgj",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000159279120b84z2",
      players: 6,
      largest: 5510,
      smallest: 5510,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000162979120ek7dp",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000157779120oo4zm",
      players: 6,
      largest: 5530,
      smallest: 5530,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000163579120w5nw8",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000161079120f1n2m",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000172479120cyiq5",
      players: 6,
      largest: 5460,
      smallest: 5460,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000171779120kpxus",
      players: 6,
      largest: 5460,
      smallest: 5460,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-00017227912016dm2",
      players: 6,
      largest: 5460,
      smallest: 5460,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000174979120bruen",
      players: 5,
      largest: 5440,
      smallest: 5440,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000171579120u5tnz",
      players: 6,
      largest: 5460,
      smallest: 5460,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000155679120gwuu5",
      players: 6,
      largest: 5590,
      smallest: 5590,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000170279120qdsnp",
      players: 6,
      largest: 5480,
      smallest: 5480,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000171979120vn8b3",
      players: 6,
      largest: 5460,
      smallest: 5460,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000170479120yb8zi",
      players: 6,
      largest: 5480,
      smallest: 5480,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000166879120t2bpn",
      players: 6,
      largest: 5490,
      smallest: 5490,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-0001735791208sgfk",
      players: 6,
      largest: 5450,
      smallest: 5450,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000156779120brfne",
      players: 6,
      largest: 5550,
      smallest: 5550,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000155879120xjnhv",
      players: 6,
      largest: 5580,
      smallest: 5580,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-0001588791207b7qt",
      players: 6,
      largest: 5510,
      smallest: 5510,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000174779120gbbnq",
      players: 5,
      largest: 5440,
      smallest: 5440,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000159079120n1wia",
      players: 6,
      largest: 5510,
      smallest: 5510,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000174279120cfe7m",
      players: 5,
      largest: 5440,
      smallest: 5440,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000168679120d1wup",
      players: 6,
      largest: 5480,
      smallest: 5480,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-0001737791200r81k",
      players: 6,
      largest: 5450,
      smallest: 5450,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000169479120z1z6t",
      players: 6,
      largest: 5480,
      smallest: 5480,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000161679120ngpdx",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000156379120b07gn",
      players: 6,
      largest: 5560,
      smallest: 5560,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000154979120bw7v0",
      players: 6,
      largest: 5630,
      smallest: 5630,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000158679120dp1qq",
      players: 6,
      largest: 5520,
      smallest: 5520,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000165479120n8rm2",
      players: 6,
      largest: 5490,
      smallest: 5490,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000159979120pbjaq",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000168479120fpao1",
      players: 6,
      largest: 5480,
      smallest: 5480,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000159579120idmmw",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000165179120cnfje",
      players: 6,
      largest: 5490,
      smallest: 5490,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-0001547791204jiht",
      players: 6,
      largest: 5710,
      smallest: 5710,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-0001607791207lcnc",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000173279120qc6ao",
      players: 6,
      largest: 5460,
      smallest: 5460,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000173079120waiya",
      players: 6,
      largest: 5460,
      smallest: 5460,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000162779120sepi6",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000167579120zk42b",
      players: 6,
      largest: 5480,
      smallest: 5480,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-0001581791208hxy3",
      players: 6,
      largest: 5530,
      smallest: 5530,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000160579120jcxlz",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000162279120id2y1",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000171079120adh2d",
      players: 6,
      largest: 5470,
      smallest: 5470,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000163279120sf324",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000163879120ak09q",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000160279120936ux",
      players: 6,
      largest: 5500,
      smallest: 5500,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-0001707791207l3xk",
      players: 6,
      largest: 5480,
      smallest: 5480,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-00015797912024dxt",
      players: 6,
      largest: 5530,
      smallest: 5530,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000156179120ouqyn",
      players: 6,
      largest: 5560,
      smallest: 5560,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-0001574791208f0ph",
      players: 6,
      largest: 5530,
      smallest: 5530,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000173979120i028i",
      players: 5,
      largest: 5440,
      smallest: 5440,
    },
    {
      domainName: "wss://13.127.91.20:8008/websocket",
      nodeIp: "13.127.91.20",
      tableId: "TOTYMW090725-000167079120qjarn",
      players: 6,
      largest: 5490,
      smallest: 5490,
    },
  ],
  highestStack: 5710,
  lowestStack: 5410,
  breakRequest: false,
  top3RankList: [
    {
      playerName: "major688352",
      displayName: null,
      chipStack: 5710,
      rank: 1,
      winningAmount: 0,
      winningBonusAmount: 0,
    },
    {
      playerName: "gold55754",
      displayName: null,
      chipStack: 5690,
      rank: 2,
      winningAmount: 0,
      winningBonusAmount: 0,
    },
    {
      playerName: "ninja575252",
      displayName: null,
      chipStack: 5690,
      rank: 2,
      winningAmount: 0,
      winningBonusAmount: 0,
    },
  ],
  qualifiedPlayerCount: 0,
  nextPrizeJumpRank: 0,
  currentAvailableFlights: 1,
  activeTables: 81,
  nextPrizeAmount: null,
  currentPrizeAmount: {
    amount: 0,
    bonus: 0,
    ticket: false,
  },
  flightsTotalEntries: 481,
  flightTotalReEntries: 0,
  activeTableCount: 81,
};

const table = [
  {
    tableId: 123,
    players: 8,
    chips: "60,543 / 15000",
  },
  {
    tableId: 123,
    players: 8,
    chips: "60,543 / 15000",
  },
  {
    tableId: 123,
    players: 8,
    chips: "60,543 / 15000",
  },
  {
    tableId: 123,
    players: 8,
    chips: "60,543 / 15000",
  },
  {
    tableId: 123,
    players: 8,
    chips: "60,543 / 15000",
  },
  {
    tableId: 123,
    players: 8,
    chips: "60,543 / 15000",
  },
  {
    tableId: 123,
    players: 8,
    chips: "60,543 / 15000",
  },
  {
    tableId: 123,
    players: 8,
    chips: "60,543 / 15000",
  },
];
